import React from 'react';
import ReactDOM from 'react-dom';
import { Store } from 'redux';
import App from './App';

window.React = React;
window.ReactDOM = ReactDOM;

export default function appRenderer(store: Store<any>) {
  ReactDOM.render(<App store={store} />, document.getElementById('lobby-root'));
}
